export { RecentlyViewedSubscriptionsQueryWrapper } from './src/recently-viewed-subscriptions-query-wrapper';
export { getRecentlyViewedSubscriptionWidgetContent } from './src/recently-viewed-subscriptions-widget-content';
